import React, {Component} from "react";
import PropTypes from "prop-types";
import TradeMarkItem from "./TradeMarkItem";
import ShareNow from "./ShareNow";
import NoResult from "./NoResult";
import PreviewResult from "./PreviewResult";

class TrademarkResults extends Component {
    render() {
        const {results, term, loading} = this.props;

        if (!results || !results.length) {
            return <NoResult loading={loading} term={term}/>;
        }

        const texts = results.map(result => {
            return result['wordMark'];
        });

        return (
            <div className="TrademarkResults">
                <PreviewResult text={term} texts={texts}/>

                <table className="table">
                    <thead>
                    <tr>
                        <th>Trademark</th>
                        <th>Serial</th>
                        <th>Register</th>
                        <th>Status</th>
                        <th>Type</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        results.map((result, index) => {
                            return <TradeMarkItem key={index} data={result}/>
                        })
                    }
                    </tbody>
                </table>

                <ShareNow/>
            </div>
        );
    }
}

TrademarkResults.propTypes = {
    term: PropTypes.string.isRequired,
    results: PropTypes.array,
    loading: PropTypes.bool,
};

export default TrademarkResults;


// WEBPACK FOOTER //
// ./src/app/home/TrademarkResults.js